import { render } from "./card-course.vue?vue&type=template&id=9c3fd8ac&ts=true"
import script from "./card-course.vue?vue&type=script&lang=ts"
export * from "./card-course.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__